<template>
  <div ref="loadingContainer" class="filterOverlay">
    <div class="content-wrapper">
      <div class="container min-width">
        <navigation></navigation>
          <section id="ReportNotFound">
          </section>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../plugins/bus'
import Navigation from '../../components/navigation/Navigation.vue'

export default {
  name: 'notFound',
  components: {
    Navigation,
  },
  mounted () {
    bus.emit('notFound')
  },
}
</script>

<style lang="scss">
@import '../../appV4';
</style>
